<template>
    <div class="compare-page">
        <div class="container">
            <div class="section-title-new title-center">
                <h1>{{ pageSetup.page_title }}</h1>
            </div>
            <div class="empty-msg-container" v-if="empty && pageSetup != null">
                <h2>{{ pageSetup.empty_compare_flats.msg }}</h2>
                <div class="instructions">
                    <h3>{{ pageSetup.empty_compare_flats.info.title }}</h3>
                    <ul>
                        <li v-for="(item, index) in pageSetup.empty_compare_flats.info.steps">
                            <span class="num">{{ index + 1}}</span>
                            <p v-if="index != 1" v-html="item.desc"></p>
                            <p v-else>
                                <span>{{ getCorrectStr(item.desc, 1) }}</span>
                                <svgIcon name="ab" class="icon-ab"/>
                                <span> {{ getCorrectStr(item.desc, 2) }}</span>
                            </p>
                        </li>
                    </ul>
                </div>
            </div>
            <flatsItemsCompare :flatsArr="dataItems" v-if="dataItems != null"></flatsItemsCompare>
        </div>
        <formPage v-if="pageSetup != null"></formPage>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import store from '@/store.js'
    import cookie from 'vue-cookie'
    const tokenAuthCrm = cookie.get('crm_auth_token');
    import svgIcon from '@/components/partials/SvgIcon.vue';
	import flatsItemsCompare from '@/components/flats-crm/flats-crm-items-compare.vue'
	import formPage from '@/components/forms/form-page.vue';	
    export default {
        name: 'compare--page',
        components: {
            flatsItemsCompare,
            formPage,
            svgIcon,
        },
        data () {
            return {
                title: 'Сравнение',
                empty: false,
                dataItems: null,
                dataResp: {
                    "apartmentIds": null,
                }
            }
        },
        computed: mapGetters({
            pageSetup: 'loadComparePage',
            ucoCRMurl: 'loadUrlCRMuco',
            ucoCRM_token_auth: 'loadUcoCRM_auth_token',
        }),
        methods: {
            getCorrectStr(str, index) {
                var clearStr;
                if (index == 1) {
                    clearStr = str.split("<span>")[0];
                    return clearStr;
                } else {
                    clearStr = str.split("<span>")[1].replace('</span>', '');
                    return clearStr;   
                }
            },
            getCompareFlats() {
                var exist = localStorage.getItem('sales_compare_flats');
                exist = exist ? exist.split(',') : [];
                // console.log(exist, exist.length);
                if (exist.length > 0) {
                    this.dataResp.apartmentIds = exist;
                    axios.post(this.ucoCRMurl + '/rest/prices/getApartments', this.dataResp, {
                        headers: { 
                            'Authorization' :  `Bearer ${this.ucoCRM_token_auth}`,
                        } 
                    }).then(async (response) => {
                        if (response.data.data.length != 0) {
                            this.dataItems = response.data.data;
                        }
                    });
                } else {
                    this.empty = true;
                }
            },
        },
        beforeRouteEnter (to, from, next) {
            if (store.state.comparePage != null) {
                next(vm => {
                    vm.getCompareFlats();
                    setTimeout(() => {
                        vm.$parent.$refs.topProgress.done();
                    }, 300);
                    vm.$store.commit('removePageLoaderImg');
                });
            } else {
                store.dispatch('getComparePage').then((response) => {
                    // console.log(response, 'how to by')
                    if (response) {
                        next(vm => {
                            vm.getCompareFlats();
                            setTimeout(() => {
                                vm.$parent.$refs.topProgress.done();
                            }, 300);
                            vm.$store.commit('removePageLoaderImg');
                        });
                    } else {
                        next(false, vm => vm.$parent.$refs.topProgress.fail());
                    }
                });
            }
        },
        beforeCreate() {
            // this.$store.dispatch('getNewsPageData');
            // this.$store.dispatch('getNewsItems');
            document.body.dataset.page = 'compare';
        },
        created () {
            document.title = this.title;
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/compare/compare-page.scss';
    @import '@/styles/components/compare/compare-page-respond.scss';
    // @import '@/styles/components/about/respond/about-page-respond.scss';
</style>